import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { pageTitle } from '../../helper'
import Accordion from '../Accordion'
import Button from '../Button'
import Cta from '../Cta'
import IconBox from '../IconBox'
import PageHeading from '../PageHeading'
import Div from '../Div'
import SectionHeading from '../SectionHeading'
import TestimonialSlider from '../Slider/TestimonialSlider'
import Spacing from '../Spacing'

export default function WebDevelopmentPage() {
    pageTitle('Web Development Services');
    const params = useParams();
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <>
            <PageHeading
                title='Web Development Services'
                bgSrc='/images/service_hero_bg.jpeg'
                pageLinkText={params.serviceDetailsId || 'Web Development'}
            />
            <Spacing lg='145' md='80'/>
            <Div className="container">
                <SectionHeading
                    title='Development Working Process'
                    subtitle='Web Development'
                    variant='cs-style1 text-center'
                />
                <Spacing lg='90' md='45'/>
                <Div className="row">
                    <Div className="col-lg-4">
                        <IconBox
                            icon='/images/icons/service_icon_1.svg'
                            title='Planning & Architecture'
                            subtitle='We begin by establishing the technical foundation of your project. Our developers work closely with stakeholders to define project scope, select appropriate technologies, and create a detailed development roadmap.'
                        />
                        <Spacing lg='30' md='30'/>
                    </Div>
                    <Div className="col-lg-4">
                        <IconBox
                            icon='/images/icons/service_icon_2.svg'
                            title='Frontend Development'
                            subtitle='Our frontend experts transform designs into responsive, interactive web experiences using modern frameworks and methodologies. We create pixel-perfect implementations that maintain design integrity across all devices.'
                        />
                        <Spacing lg='30' md='30'/>
                    </Div>
                    <Div className="col-lg-4">
                        <IconBox
                            icon='/images/icons/service_icon_3.svg'
                            title='Backend Development'
                            subtitle="Our backend specialists build powerful, secure systems to manage your data and business logic. We develop scalable APIs, database structures, and server-side components that support your application's functionality."
            />
            <Spacing lg='30' md='30'/>
                    </Div>
                </Div>
            </Div>
            <Spacing lg='120' md='50'/>
            <Div className="container">
                <Div className="row">
                    <Div className="col-lg-6">
                        <h2 className="cs-font_30 cs-m0">Transform your digital presence</h2>
                        <Spacing lg='30' md='30'/>
                        <p>At ACE Cloud Solution, we transform design concepts into powerful, functional websites and web applications through our comprehensive development approach. Our expert team delivers robust, scalable solutions that drive your business forward.</p>
                        <p>We build high-performance web solutions that deliver exceptional user experiences while achieving your business objectives. From responsive websites to complex web applications, our development team combines technical expertise with strategic thinking.</p>
                        <Spacing lg='30' md='30'/>
                        <h3 className="cs-font_22 cs-m0">Key benefits of our development:</h3>
                        <Spacing lg='15' md='15'/>
                        <ul className="cs-list cs-style1">
                            <li>Clean, efficient code that ensures fast loading times</li>
                            <li>Mobile-first responsive design for all screen sizes</li>
                            <li>SEO-friendly architecture to improve visibility</li>
                            <li>Scalable solutions that grow with your business</li>
                            <li>Rigorous testing for cross-browser compatibility</li>
                        </ul>
                    </Div>
                    <Div className="col-lg-5 offset-lg-1">
                        <Div className="cs-image_layer cs-style1">
                            <Div className="cs-image_layer_in">
                                <img src="/images/service_2.jpeg" alt="Web Development" className="w-100" />
                            </Div>
                        </Div>
                        <Spacing lg='0' md='40'/>
                    </Div>
                </Div>
            </Div>
            <Spacing lg='100' md='80'/>
            <Div className="container">
                <Div className="row align-items-center">
                    <Div className="col-xl-5 col-lg-6">
                        <Div className="cs-radius_15 cs-shine_hover_1">
                            <img src="/images/service_img_1.jpeg" alt="Service" className='cs-radius_15 w-100' />
                        </Div>
                        <Spacing lg='0' md='40'/>
                    </Div>
                    <Div className="col-lg-6 offset-xl-1">
                        <h2 className="cs-font_50 cs-m0">Below our most development related services</h2>
                        <Spacing lg='50' md='30'/>
                        <Div className="row">
                            <Div className="col-lg-6">
                                <Button btnLink='' btnText='Responsive website' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='E-commerce platform' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='Web application' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='CMS implementation' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='Frontend development' variant='cs-type2'/>
                                <Spacing lg='0' md='10'/>
                            </Div>
                            <Div className="col-lg-6">
                                <Button btnLink='' btnText='Backend development' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='Website maintenance' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='Performance optimization' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='API development' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='Custom web solutions' variant='cs-type2'/>
                                <Spacing lg='0' md='10'/>
                            </Div>
                        </Div>
                    </Div>
                </Div>
            </Div>
            <Spacing lg='150' md='80'/>
            {/*<TestimonialSlider />*/}
            <Spacing lg='145' md='80'/>
            <Div className="container cs-shape_wrap_4">
                <Div className="cs-shape_4"></Div>
                <Div className="cs-shape_4"></Div>
                <Div className="container">
                    <Div className="row">
                        <Div className="col-xl-5 col-lg-6">
                            <SectionHeading
                                title='Some pre questions and answers'
                                subtitle="FAQ's"
              />
              <Spacing lg='90' md='45'/>
                        </Div>
                        <Div className="col-lg-6 offset-xl-1">
                            <Accordion/>
                        </Div>
                    </Div>
                </Div>
            </Div>
            <Spacing lg='150' md='80'/>
            <Div className="container">
                <Cta
                    title="Let's build <br />something <i>powerful</i> together"
                    btnText='Schedule a Consultation'
                    btnLink='/contact'
                    bgSrc='/images/cta_bg.jpeg'
                    />
            </Div>
        </>
    )
}